var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "047a8d2dc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.789062 39.46875 L 57.828125 39.46875 L 57.828125 110.558594 L 8.789062 110.558594 Z M 8.789062 39.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7b53f99646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.816406 75 C 54 67.636719 48.578125 61.871094 44.347656 58.335938 C 42.59375 56.871094 40.898438 55.652344 39.453125 54.703125 C 38.46875 54.453125 37.429688 54.214844 36.332031 53.988281 C 15.757812 49.773438 8.789062 39.46875 8.789062 39.46875 C 8.789062 39.46875 13.957031 59.03125 23.296875 72.460938 C 29.230469 80.996094 39.582031 83.890625 49.9375 82.855469 C 46.449219 83.828125 41.992188 85.570312 37.558594 88.695312 C 33.921875 91.253906 25.089844 98.730469 37.875 110.558594 C 37.875 110.558594 32.871094 101.496094 49.898438 97.769531 C 52.179688 97.273438 54.074219 96.609375 55.640625 95.742188 C 55.601562 94.515625 55.644531 93.308594 55.789062 92.132812 C 56.078125 89.761719 56.558594 88.359375 56.984375 87.125 C 57.410156 85.882812 57.75 84.90625 57.808594 83.011719 C 57.878906 80.820312 57.679688 80.34375 57.199219 79.191406 C 56.839844 78.324219 56.347656 77.136719 55.816406 75 Z M 55.816406 75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "859441fd75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.816406 75 C 54 67.636719 48.578125 61.871094 44.347656 58.335938 C 42.59375 56.871094 40.898438 55.652344 39.453125 54.703125 C 38.46875 54.453125 37.429688 54.214844 36.332031 53.988281 C 15.757812 49.773438 8.789062 39.46875 8.789062 39.46875 C 8.789062 39.46875 13.957031 59.03125 23.296875 72.460938 C 29.230469 80.996094 39.582031 83.890625 49.9375 82.855469 C 46.449219 83.828125 41.992188 85.570312 37.558594 88.695312 C 33.921875 91.253906 25.089844 98.730469 37.875 110.558594 C 37.875 110.558594 32.871094 101.496094 49.898438 97.769531 C 52.179688 97.273438 54.074219 96.609375 55.640625 95.742188 C 55.601562 94.515625 55.644531 93.308594 55.789062 92.132812 C 56.078125 89.761719 56.558594 88.359375 56.984375 87.125 C 57.410156 85.882812 57.75 84.90625 57.808594 83.011719 C 57.878906 80.820312 57.679688 80.34375 57.199219 79.191406 C 56.839844 78.324219 56.347656 77.136719 55.816406 75 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.00000225813,
    gradientTransform: "matrix(49.034507, 0, 0, 48.751502, 8.787934, 75.013383)",
    y1: 0,
    x2: 1.000135,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "f21dd8c524"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.598633%, 11.799622%, 57.998657%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.398743%, 11.799622%, 57.998657%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.198853%, 11.799622%, 57.998657%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.863159%, 11.999512%, 57.998657%)",
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.528992%, 12.199402%, 57.998657%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.29248%, 12.199402%, 57.998657%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.057495%, 12.199402%, 57.998657%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.86676%, 12.199402%, 57.998657%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.286926%, 12.199402%, 57.798767%)",
    offset: 0.0351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.896301%, 12.199402%, 57.598877%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.697937%, 12.199402%, 57.598877%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.499573%, 12.199402%, 57.598877%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.116577%, 12.199402%, 57.598877%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.735107%, 12.199402%, 57.598877%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.544373%, 12.199402%, 57.598877%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.926392%, 12.208557%, 57.598877%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.499146%, 12.217712%, 57.598877%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.296204%, 12.358093%, 57.598877%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.093262%, 12.5%, 57.598877%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.896423%, 12.5%, 57.598877%)",
    offset: 0.0820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.699585%, 12.5%, 57.598877%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.365417%, 12.5%, 57.598877%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.032776%, 12.5%, 57.598877%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.842041%, 12.5%, 57.598877%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.225586%, 12.5%, 57.598877%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.799866%, 12.5%, 57.598877%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.595398%, 12.5%, 57.598877%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.39093%, 12.5%, 57.598877%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.194092%, 12.5%, 57.598877%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.998779%, 12.5%, 57.598877%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.614258%, 12.69989%, 57.598877%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.229736%, 12.89978%, 57.598877%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.014587%, 12.89978%, 57.598877%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.799438%, 12.89978%, 57.598877%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.399658%, 12.89978%, 57.598877%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.999878%, 12.89978%, 57.598877%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.79541%, 12.89978%, 57.598877%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.590942%, 12.89978%, 57.598877%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.444458%, 12.89978%, 57.598877%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.913452%, 12.89978%, 57.598877%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.527405%, 12.89978%, 57.598877%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.312256%, 12.89978%, 57.598877%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.098633%, 12.89978%, 57.598877%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.732422%, 13.09967%, 57.598877%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.366211%, 13.299561%, 57.598877%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.125122%, 13.299561%, 57.598877%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.885559%, 13.299561%, 57.598877%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.494934%, 13.299561%, 57.598877%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.104309%, 13.299561%, 57.598877%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.913574%, 13.299561%, 57.598877%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.510742%, 13.299561%, 57.598877%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.298645%, 13.299561%, 57.598877%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.930908%, 13.299561%, 57.598877%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.563171%, 13.299561%, 57.598877%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.372437%, 13.499451%, 57.598877%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.181702%, 13.699341%, 57.598877%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.791077%, 13.699341%, 57.598877%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.401978%, 13.699341%, 57.598877%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.211243%, 13.699341%, 57.598877%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.809937%, 13.699341%, 57.598877%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.599365%, 13.699341%, 57.598877%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.228577%, 13.699341%, 57.598877%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.859314%, 13.699341%, 57.598877%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.618225%, 13.699341%, 57.598877%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.378662%, 13.699341%, 57.598877%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.988037%, 13.899231%, 57.598877%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.598938%, 14.099121%, 57.598877%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.408203%, 14.099121%, 57.598877%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.87262%, 14.099121%, 57.598877%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.527771%, 14.099121%, 57.598877%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.341614%, 14.099121%, 57.598877%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.928101%, 14.099121%, 57.598877%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.699219%, 14.099121%, 57.598877%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.296387%, 14.099121%, 57.598877%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.895081%, 14.099121%, 57.598877%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.696716%, 14.291382%, 57.598877%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 14.483643%, 57.598877%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.116882%, 14.491272%, 57.598877%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.735413%, 14.498901%, 57.598877%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.544678%, 14.498901%, 57.598877%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.963318%, 14.498901%, 57.598877%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.574219%, 14.498901%, 57.598877%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.33313%, 14.498901%, 57.449341%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.093567%, 14.498901%, 57.299805%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.896729%, 14.498901%, 57.299805%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.69989%, 14.498901%, 57.299805%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.365723%, 14.698792%, 57.299805%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.031555%, 14.898682%, 57.299805%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.84082%, 14.898682%, 57.299805%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.260986%, 14.898682%, 57.299805%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.870361%, 14.898682%, 57.299805%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.629272%, 14.898682%, 57.299805%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.389709%, 14.898682%, 57.299805%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.194397%, 14.898682%, 57.299805%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.613037%, 15.083313%, 57.299805%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.228516%, 15.26947%, 57.299805%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.013367%, 15.284729%, 57.299805%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.799744%, 15.299988%, 57.299805%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.433533%, 15.299988%, 57.299805%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.067322%, 15.299988%, 57.299805%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.876587%, 15.299988%, 57.299805%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.296753%, 15.299988%, 57.299805%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.906128%, 15.299988%, 57.299805%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.715393%, 15.299988%, 57.299805%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.312561%, 15.499878%, 57.299805%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.098938%, 15.699768%, 57.299805%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.731201%, 15.699768%, 57.299805%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.36499%, 15.699768%, 57.299805%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.131531%, 15.699768%, 57.299805%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.899597%, 15.699768%, 57.299805%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.501343%, 15.699768%, 57.299805%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.103088%, 15.699768%, 57.299805%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.912354%, 15.699768%, 57.299805%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.33252%, 15.899658%, 57.299805%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.941895%, 16.099548%, 57.299805%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.75116%, 16.099548%, 57.299805%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.380371%, 16.099548%, 57.299805%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.799011%, 16.099548%, 57.299805%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.400757%, 16.099548%, 57.299805%)",
    offset: 0.523437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.199341%, 16.099548%, 57.299805%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.999451%, 16.099548%, 57.299805%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.619507%, 16.278076%, 57.299805%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.239563%, 16.45813%, 57.299805%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.048828%, 16.477966%, 57.299805%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.468994%, 16.499329%, 57.299805%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.078369%, 16.499329%, 57.299805%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.887634%, 16.499329%, 57.299805%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.448181%, 16.499329%, 57.299805%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 16.499329%, 57.299805%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.86377%, 16.699219%, 57.299805%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.528076%, 16.899109%, 57.299805%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.341919%, 16.899109%, 57.299805%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.765137%, 16.899109%, 57.299805%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.376038%, 16.899109%, 57.299805%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.185303%, 16.899109%, 57.299805%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.74585%, 16.899109%, 57.299805%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.498657%, 16.899109%, 57.299805%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.115662%, 17.098999%, 57.299805%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.734192%, 17.298889%, 57.299805%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.515991%, 17.298889%, 57.299805%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.299316%, 17.298889%, 57.299805%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.936157%, 17.298889%, 57.299805%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.572998%, 17.298889%, 57.299805%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.382263%, 17.298889%, 57.299805%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.800903%, 17.442322%, 57.299805%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.411804%, 17.58728%, 57.299805%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.221069%, 17.593384%, 57.299805%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.81366%, 17.599487%, 57.299805%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.598511%, 17.599487%, 57.299805%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.233826%, 17.599487%, 57.299805%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.869141%, 17.599487%, 57.299805%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.634155%, 17.599487%, 57.299805%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.39917%, 17.599487%, 57.299805%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.054321%, 17.799377%, 57.299805%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.709473%, 17.999268%, 57.299805%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.468384%, 17.999268%, 57.299805%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.228821%, 17.999268%, 57.299805%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.838196%, 17.999268%, 57.299805%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.447571%, 17.999268%, 57.299805%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.256836%, 17.999268%, 57.299805%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.715149%, 18.154907%, 57.299805%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.364197%, 18.312073%, 57.299805%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.184143%, 18.354797%, 57.299805%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.752319%, 18.399048%, 57.299805%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.499023%, 18.399048%, 57.299805%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.122131%, 18.399048%, 57.299805%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.745239%, 18.399048%, 57.299805%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.522461%, 18.399048%, 57.299805%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.299683%, 18.399048%, 57.299805%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.941101%, 18.598938%, 57.299805%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.584045%, 18.798828%, 57.299805%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.393311%, 18.798828%, 57.299805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.766174%, 18.798828%, 57.299805%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.329773%, 18.798828%, 57.299805%)",
    offset: 0.773437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.135986%, 18.798828%, 57.299805%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.720947%, 18.998718%, 57.299805%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.499695%, 19.198608%, 57.299805%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.189941%, 19.198608%, 57.299805%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.880188%, 19.198608%, 57.299805%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.639099%, 19.198608%, 57.299805%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.399536%, 19.198608%, 57.299805%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.059265%, 19.198608%, 57.299805%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.718994%, 19.198608%, 57.299805%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.477905%, 19.378662%, 57.299805%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.238342%, 19.560242%, 57.299805%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.847717%, 19.580078%, 57.299805%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.458618%, 19.599915%, 57.299805%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.267883%, 19.599915%, 57.299805%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.837585%, 19.599915%, 57.299805%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.599548%, 19.599915%, 57.299805%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.257751%, 19.740295%, 57.299805%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.915955%, 19.882202%, 57.299805%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.706909%, 19.940186%, 57.299805%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.49939%, 19.999695%, 57.299805%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.127075%, 19.999695%, 57.299805%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.754761%, 19.999695%, 57.299805%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.564026%, 19.999695%, 57.299805%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.984192%, 20.152283%, 57.299805%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.593567%, 20.304871%, 57.299805%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.402832%, 20.352173%, 57.299805%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.95575%, 20.399475%, 57.299805%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.699402%, 20.399475%, 57.299805%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.325562%, 20.399475%, 57.299805%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.953247%, 20.399475%, 57.299805%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.725891%, 20.562744%, 57.299805%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 20.726013%, 57.299805%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.144531%, 20.762634%, 57.299805%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.792053%, 20.799255%, 57.299805%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.636414%, 20.799255%, 57.299805%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.105408%, 20.799255%, 57.299805%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.730042%, 20.799255%, 57.299805%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.488953%, 20.973206%, 57.299805%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.24939%, 21.148682%, 57.299805%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.858765%, 21.173096%, 57.299805%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.469666%, 21.199036%, 57.299805%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.278931%, 21.199036%, 57.299805%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.844055%, 21.199036%, 57.299805%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 21.199036%, 57.299805%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.262695%, 21.398926%, 57.299805%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.927002%, 21.598816%, 57.299805%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.663025%, 21.598816%, 57.299805%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.399048%, 21.598816%, 57.299805%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.032837%, 21.598816%, 57.299805%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.666626%, 21.598816%, 57.299805%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.515564%, 21.598816%, 57.299805%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17d92195a5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 59 54.320312 L 70.25 54.320312 L 70.25 65.507812 L 59 65.507812 Z M 59 54.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7fdee93d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.25 59.914062 C 70.25 63.003906 67.730469 65.507812 64.625 65.507812 C 61.515625 65.507812 59 63.003906 59 59.914062 C 59 56.824219 61.515625 54.320312 64.625 54.320312 C 67.730469 54.320312 70.25 56.824219 70.25 59.914062 Z M 70.25 59.914062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96c8ed1f80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.25 59.914062 C 70.25 63.003906 67.730469 65.507812 64.625 65.507812 C 61.515625 65.507812 59 63.003906 59 59.914062 C 59 56.824219 61.515625 54.320312 64.625 54.320312 C 67.730469 54.320312 70.25 56.824219 70.25 59.914062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0, 0.997106, -1.002894, 0, 64.05456, 53.920319)",
    gradientUnits: "userSpaceOnUse",
    r: 51.811679,
    cx: 0,
    id: "86018bbafc",
    cy: 0,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.40332%, 11.799622%, 57.998657%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.012695%, 11.799622%, 57.998657%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.808228%, 11.984253%, 57.998657%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.663269%, 12.184143%, 57.998657%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.336731%, 12.199402%, 57.998657%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.10022%, 12.199402%, 57.998657%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.860657%, 12.199402%, 57.998657%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.470032%, 12.199402%, 57.998657%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.087036%, 12.199402%, 57.991028%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.896301%, 12.199402%, 57.791138%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.697937%, 12.199402%, 57.598877%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.307312%, 12.199402%, 57.598877%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.105896%, 12.199402%, 57.598877%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.915161%, 12.199402%, 57.598877%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.535217%, 12.199402%, 57.598877%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.318542%, 12.199402%, 57.598877%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.078979%, 12.214661%, 57.598877%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.66394%, 12.364197%, 57.598877%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.283997%, 12.5%, 57.598877%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.093262%, 12.5%, 57.598877%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.891846%, 12.5%, 57.598877%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.550049%, 12.5%, 57.598877%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.400513%, 12.5%, 57.598877%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.211304%, 12.5%, 57.598877%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.828308%, 12.5%, 57.598877%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.616211%, 12.5%, 57.598877%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.375122%, 12.5%, 57.598877%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.957031%, 12.5%, 57.598877%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.580139%, 12.5%, 57.598877%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.389404%, 12.5%, 57.598877%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.184937%, 12.504578%, 57.598877%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.794312%, 12.704468%, 57.598877%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.598999%, 12.89978%, 57.598877%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.408264%, 12.89978%, 57.598877%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.022217%, 12.89978%, 57.598877%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.631592%, 12.89978%, 57.598877%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.417969%, 12.89978%, 57.598877%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.17688%, 12.89978%, 57.598877%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.7771%, 12.89978%, 57.598877%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.589417%, 12.89978%, 57.598877%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.432251%, 12.89978%, 57.598877%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.088928%, 12.89978%, 57.598877%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.698303%, 12.89978%, 57.598877%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.501465%, 12.89978%, 57.598877%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.31073%, 12.89978%, 57.598877%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.926208%, 13.082886%, 57.598877%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.714111%, 13.282776%, 57.598877%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.523376%, 13.299561%, 57.598877%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.123596%, 13.299561%, 57.598877%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.882507%, 13.299561%, 57.598877%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.671936%, 13.299561%, 57.598877%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.281311%, 13.299561%, 57.598877%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.892212%, 13.299561%, 57.598877%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.699951%, 13.299561%, 57.598877%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.50769%, 13.299561%, 57.598877%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.120117%, 13.299561%, 57.598877%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.911072%, 13.299561%, 57.598877%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.720337%, 13.299561%, 57.598877%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.348022%, 13.499451%, 57.598877%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.975708%, 13.699341%, 57.598877%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.784973%, 13.699341%, 57.598877%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.575928%, 13.699341%, 57.598877%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.18988%, 13.699341%, 57.598877%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.999146%, 13.699341%, 57.598877%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.803833%, 13.699341%, 57.598877%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.413208%, 13.699341%, 57.598877%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.027161%, 13.699341%, 57.598877%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.641113%, 13.699341%, 57.598877%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.221497%, 13.699341%, 57.598877%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.981934%, 13.716125%, 57.598877%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.769836%, 13.916016%, 57.598877%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.383789%, 14.099121%, 57.598877%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.997742%, 14.099121%, 57.598877%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.654419%, 14.099121%, 57.598877%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.314148%, 14.099121%, 57.598877%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.929626%, 14.099121%, 57.598877%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.545105%, 14.099121%, 57.598877%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.304016%, 14.099121%, 57.598877%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.062927%, 14.11438%, 57.598877%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.672302%, 14.31427%, 57.598877%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.286255%, 14.498901%, 57.598877%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.900208%, 14.498901%, 57.598877%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.509583%, 14.498901%, 57.598877%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.123535%, 14.498901%, 57.598877%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.739014%, 14.498901%, 57.598877%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.497925%, 14.498901%, 57.449341%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.256836%, 14.498901%, 57.299805%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.869263%, 14.498901%, 57.299805%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.538147%, 14.508057%, 57.299805%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.394714%, 14.707947%, 57.299805%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.194824%, 14.898682%, 57.299805%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.804199%, 14.898682%, 57.299805%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.418152%, 14.898682%, 57.299805%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.032104%, 14.898682%, 57.299805%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.641479%, 14.898682%, 57.299805%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.400391%, 14.898682%, 57.299805%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.160828%, 14.898682%, 57.299805%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.77478%, 14.906311%, 57.299805%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.388733%, 15.107727%, 57.299805%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.998108%, 15.299988%, 57.299805%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.607483%, 15.299988%, 57.299805%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.221436%, 15.299988%, 57.299805%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.835388%, 15.299988%, 57.299805%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.449341%, 15.299988%, 57.299805%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.063293%, 15.299988%, 57.299805%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.677246%, 15.306091%, 57.299805%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.291199%, 15.505981%, 57.299805%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.900574%, 15.699768%, 57.299805%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.514526%, 15.699768%, 57.299805%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.128479%, 15.699768%, 57.299805%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.737854%, 15.699768%, 57.299805%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.496765%, 15.699768%, 57.299805%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.257202%, 15.699768%, 57.299805%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.871155%, 15.708923%, 57.299805%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.485107%, 15.908813%, 57.299805%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.094482%, 16.099548%, 57.299805%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.708435%, 16.099548%, 57.299805%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.368164%, 16.099548%, 57.299805%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.027893%, 16.099548%, 57.299805%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.817322%, 16.099548%, 57.299805%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.576233%, 16.099548%, 57.299805%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.176453%, 16.099548%, 57.299805%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.985718%, 16.111755%, 57.299805%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.778198%, 16.311646%, 57.299805%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.387573%, 16.499329%, 57.299805%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.996948%, 16.499329%, 57.299805%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.80011%, 16.499329%, 57.299805%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.609375%, 16.499329%, 57.299805%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.226379%, 16.499329%, 57.299805%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.014282%, 16.499329%, 57.299805%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.823547%, 16.499329%, 57.299805%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.403931%, 16.499329%, 57.299805%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.97821%, 16.514587%, 57.299805%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.790527%, 16.714478%, 57.299805%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.634888%, 16.899109%, 57.299805%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.293091%, 16.899109%, 57.299805%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.099304%, 16.899109%, 57.299805%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.907043%, 16.899109%, 57.299805%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.51947%, 16.899109%, 57.299805%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.128845%, 16.899109%, 57.299805%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.916748%, 16.899109%, 57.299805%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.675659%, 16.899109%, 57.299805%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.275879%, 16.917419%, 57.299805%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.085144%, 17.11731%, 57.299805%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.876099%, 17.298889%, 57.299805%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.485474%, 17.298889%, 57.299805%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.094849%, 17.298889%, 57.299805%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.899536%, 17.298889%, 57.299805%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.708801%, 17.298889%, 57.299805%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.322754%, 17.298889%, 57.299805%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.936707%, 17.298889%, 57.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.550659%, 17.448425%, 57.299805%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.164612%, 17.599487%, 57.299805%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.778564%, 17.599487%, 57.299805%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.390991%, 17.599487%, 57.299805%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.004944%, 17.599487%, 57.299805%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.615845%, 17.599487%, 57.299805%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.22522%, 17.599487%, 57.299805%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.014648%, 17.778015%, 57.299805%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.823914%, 17.977905%, 57.299805%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.424133%, 17.999268%, 57.299805%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.183044%, 17.999268%, 57.299805%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.972473%, 17.999268%, 57.299805%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.581848%, 17.999268%, 57.299805%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.192749%, 17.999268%, 57.299805%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.806702%, 17.999268%, 57.299805%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.466431%, 18.186951%, 57.299805%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.130737%, 18.386841%, 57.299805%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.697388%, 18.399048%, 57.299805%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.260986%, 18.399048%, 57.299805%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.876465%, 18.399048%, 57.299805%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.490417%, 18.399048%, 57.299805%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.10437%, 18.59436%, 57.299805%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.713745%, 18.79425%, 57.299805%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.32312%, 18.798828%, 57.299805%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.112549%, 18.798828%, 57.299805%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.921814%, 18.798828%, 57.299805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.522034%, 18.798828%, 57.299805%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.280945%, 18.798828%, 57.299805%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.068848%, 18.811035%, 57.299805%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.679749%, 19.010925%, 57.299805%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.342529%, 19.198608%, 57.299805%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.199097%, 19.198608%, 57.299805%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.00531%, 19.198608%, 57.299805%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.616211%, 19.198608%, 57.299805%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.410217%, 19.198608%, 57.299805%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.219482%, 19.198608%, 57.299805%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.844116%, 19.198608%, 57.299805%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.422974%, 19.218445%, 57.299805%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.183411%, 19.419861%, 57.299805%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.972839%, 19.599915%, 57.299805%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.586792%, 19.599915%, 57.299805%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.200745%, 19.599915%, 57.299805%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.81012%, 19.599915%, 57.299805%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.419495%, 19.599915%, 57.299805%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.033447%, 19.776917%, 57.299805%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.651978%, 19.976807%, 57.299805%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.26593%, 19.999695%, 57.299805%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.875305%, 19.999695%, 57.299805%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.489258%, 19.999695%, 57.299805%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.10321%, 19.999695%, 57.299805%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.712585%, 20.19043%, 57.299805%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.508118%, 20.39032%, 57.299805%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.317383%, 20.399475%, 57.299805%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.942017%, 20.399475%, 57.299805%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.5224%, 20.399475%, 57.299805%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.281311%, 20.399475%, 57.299805%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.069214%, 20.399475%, 57.299805%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.686218%, 20.407104%, 57.299805%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.495483%, 20.606995%, 57.299805%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.297119%, 20.799255%, 57.299805%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.906494%, 20.799255%, 57.299805%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.555542%, 20.799255%, 57.299805%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.219849%, 20.799255%, 57.299805%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.844482%, 20.799255%, 57.299805%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 20.999146%, 57.299805%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.183777%, 21.199036%, 57.299805%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.973206%, 21.199036%, 57.299805%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.588684%, 21.199036%, 57.299805%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.397949%, 21.199036%, 57.299805%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.201111%, 21.199036%, 57.299805%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.810486%, 21.199036%, 57.299805%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.419861%, 21.199036%, 57.299805%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.210815%, 21.382141%, 57.299805%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.020081%, 21.582031%, 57.299805%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.6203%, 21.598816%, 57.299805%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.380737%, 21.598816%, 57.299805%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.167114%, 21.598816%, 57.299805%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.778015%, 21.598816%, 57.299805%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.442322%, 21.598816%, 57.299805%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.298889%, 21.598816%, 57.299805%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fc8b964002"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.191406 50.464844 L 93.054688 50.464844 L 93.054688 118.214844 L 36.191406 118.214844 Z M 36.191406 50.464844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d6e7f88e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.054688 50.464844 C 76.222656 56.535156 69.554688 67.855469 64.625 67.855469 C 59.695312 67.855469 53.023438 56.535156 36.191406 50.464844 C 36.191406 50.464844 53.976562 59.199219 57.761719 74.523438 C 59 79.535156 59.949219 78.726562 59.808594 83.078125 C 59.675781 87.210938 58.335938 87.777344 57.773438 92.375 C 56.441406 103.316406 64.625 118.222656 64.625 118.222656 C 64.625 118.222656 72.808594 103.316406 71.472656 92.375 C 70.910156 87.777344 69.570312 87.210938 69.4375 83.078125 C 69.300781 78.726562 70.25 79.535156 71.484375 74.523438 C 75.269531 59.199219 93.054688 50.464844 93.054688 50.464844 Z M 93.054688 50.464844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d6799346d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 93.054688 50.464844 C 76.222656 56.535156 69.554688 67.855469 64.625 67.855469 C 59.695312 67.855469 53.023438 56.535156 36.191406 50.464844 C 36.191406 50.464844 53.976562 59.199219 57.761719 74.523438 C 59 79.535156 59.949219 78.726562 59.808594 83.078125 C 59.675781 87.210938 58.335938 87.777344 57.773438 92.375 C 56.441406 103.316406 64.625 118.222656 64.625 118.222656 C 64.625 118.222656 72.808594 103.316406 71.472656 92.375 C 70.910156 87.777344 69.570312 87.210938 69.4375 83.078125 C 69.300781 78.726562 70.25 79.535156 71.484375 74.523438 C 75.269531 59.199219 93.054688 50.464844 93.054688 50.464844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0, 0.997106, -1.002894, 0, 64.05456, 53.920319)",
    gradientUnits: "userSpaceOnUse",
    r: 51.811679,
    cx: 0,
    id: "0821a32fe1",
    cy: 0,
    fx: 0,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.40332%, 11.799622%, 57.998657%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.012695%, 11.799622%, 57.998657%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.808228%, 11.984253%, 57.998657%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.663269%, 12.184143%, 57.998657%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.336731%, 12.199402%, 57.998657%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.10022%, 12.199402%, 57.998657%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.860657%, 12.199402%, 57.998657%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.470032%, 12.199402%, 57.998657%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.087036%, 12.199402%, 57.991028%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.896301%, 12.199402%, 57.791138%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.697937%, 12.199402%, 57.598877%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.307312%, 12.199402%, 57.598877%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.105896%, 12.199402%, 57.598877%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.915161%, 12.199402%, 57.598877%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.535217%, 12.199402%, 57.598877%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.318542%, 12.199402%, 57.598877%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.078979%, 12.214661%, 57.598877%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.66394%, 12.364197%, 57.598877%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.283997%, 12.5%, 57.598877%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.093262%, 12.5%, 57.598877%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.891846%, 12.5%, 57.598877%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.550049%, 12.5%, 57.598877%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.400513%, 12.5%, 57.598877%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.211304%, 12.5%, 57.598877%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.828308%, 12.5%, 57.598877%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.616211%, 12.5%, 57.598877%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.375122%, 12.5%, 57.598877%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.957031%, 12.5%, 57.598877%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.580139%, 12.5%, 57.598877%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.389404%, 12.5%, 57.598877%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.184937%, 12.504578%, 57.598877%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.794312%, 12.704468%, 57.598877%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.598999%, 12.89978%, 57.598877%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.408264%, 12.89978%, 57.598877%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.022217%, 12.89978%, 57.598877%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.631592%, 12.89978%, 57.598877%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.417969%, 12.89978%, 57.598877%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.17688%, 12.89978%, 57.598877%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.7771%, 12.89978%, 57.598877%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.589417%, 12.89978%, 57.598877%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.432251%, 12.89978%, 57.598877%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.088928%, 12.89978%, 57.598877%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.698303%, 12.89978%, 57.598877%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.501465%, 12.89978%, 57.598877%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.31073%, 12.89978%, 57.598877%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.926208%, 13.082886%, 57.598877%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.714111%, 13.282776%, 57.598877%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.523376%, 13.299561%, 57.598877%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.123596%, 13.299561%, 57.598877%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.882507%, 13.299561%, 57.598877%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.671936%, 13.299561%, 57.598877%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.281311%, 13.299561%, 57.598877%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.892212%, 13.299561%, 57.598877%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.699951%, 13.299561%, 57.598877%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.50769%, 13.299561%, 57.598877%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.120117%, 13.299561%, 57.598877%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.911072%, 13.299561%, 57.598877%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.720337%, 13.299561%, 57.598877%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.348022%, 13.499451%, 57.598877%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.975708%, 13.699341%, 57.598877%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.784973%, 13.699341%, 57.598877%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.575928%, 13.699341%, 57.598877%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.18988%, 13.699341%, 57.598877%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.999146%, 13.699341%, 57.598877%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.803833%, 13.699341%, 57.598877%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.413208%, 13.699341%, 57.598877%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.027161%, 13.699341%, 57.598877%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.641113%, 13.699341%, 57.598877%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.221497%, 13.699341%, 57.598877%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.981934%, 13.716125%, 57.598877%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.769836%, 13.916016%, 57.598877%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.383789%, 14.099121%, 57.598877%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.997742%, 14.099121%, 57.598877%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.654419%, 14.099121%, 57.598877%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.314148%, 14.099121%, 57.598877%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.929626%, 14.099121%, 57.598877%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.545105%, 14.099121%, 57.598877%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.304016%, 14.099121%, 57.598877%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.062927%, 14.11438%, 57.598877%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.672302%, 14.31427%, 57.598877%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.286255%, 14.498901%, 57.598877%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.900208%, 14.498901%, 57.598877%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.509583%, 14.498901%, 57.598877%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.123535%, 14.498901%, 57.598877%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.739014%, 14.498901%, 57.598877%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.497925%, 14.498901%, 57.449341%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.256836%, 14.498901%, 57.299805%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.869263%, 14.498901%, 57.299805%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.538147%, 14.508057%, 57.299805%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.394714%, 14.707947%, 57.299805%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.194824%, 14.898682%, 57.299805%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.804199%, 14.898682%, 57.299805%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.418152%, 14.898682%, 57.299805%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.032104%, 14.898682%, 57.299805%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.641479%, 14.898682%, 57.299805%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.400391%, 14.898682%, 57.299805%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.160828%, 14.898682%, 57.299805%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.77478%, 14.906311%, 57.299805%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.388733%, 15.107727%, 57.299805%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.998108%, 15.299988%, 57.299805%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.607483%, 15.299988%, 57.299805%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.221436%, 15.299988%, 57.299805%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.835388%, 15.299988%, 57.299805%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.449341%, 15.299988%, 57.299805%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.063293%, 15.299988%, 57.299805%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.677246%, 15.306091%, 57.299805%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.291199%, 15.505981%, 57.299805%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.900574%, 15.699768%, 57.299805%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.514526%, 15.699768%, 57.299805%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.128479%, 15.699768%, 57.299805%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.737854%, 15.699768%, 57.299805%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.496765%, 15.699768%, 57.299805%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.257202%, 15.699768%, 57.299805%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.871155%, 15.708923%, 57.299805%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.485107%, 15.908813%, 57.299805%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.094482%, 16.099548%, 57.299805%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.708435%, 16.099548%, 57.299805%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.368164%, 16.099548%, 57.299805%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.027893%, 16.099548%, 57.299805%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.817322%, 16.099548%, 57.299805%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.576233%, 16.099548%, 57.299805%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.176453%, 16.099548%, 57.299805%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.985718%, 16.111755%, 57.299805%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.778198%, 16.311646%, 57.299805%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.387573%, 16.499329%, 57.299805%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.996948%, 16.499329%, 57.299805%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.80011%, 16.499329%, 57.299805%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.609375%, 16.499329%, 57.299805%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.226379%, 16.499329%, 57.299805%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.014282%, 16.499329%, 57.299805%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.823547%, 16.499329%, 57.299805%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.403931%, 16.499329%, 57.299805%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.97821%, 16.514587%, 57.299805%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.790527%, 16.714478%, 57.299805%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.634888%, 16.899109%, 57.299805%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.293091%, 16.899109%, 57.299805%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.099304%, 16.899109%, 57.299805%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.907043%, 16.899109%, 57.299805%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.51947%, 16.899109%, 57.299805%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.128845%, 16.899109%, 57.299805%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.916748%, 16.899109%, 57.299805%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.675659%, 16.899109%, 57.299805%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.275879%, 16.917419%, 57.299805%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.085144%, 17.11731%, 57.299805%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.876099%, 17.298889%, 57.299805%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.485474%, 17.298889%, 57.299805%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.094849%, 17.298889%, 57.299805%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.899536%, 17.298889%, 57.299805%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.708801%, 17.298889%, 57.299805%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.322754%, 17.298889%, 57.299805%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.936707%, 17.298889%, 57.299805%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.550659%, 17.448425%, 57.299805%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.164612%, 17.599487%, 57.299805%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.778564%, 17.599487%, 57.299805%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.390991%, 17.599487%, 57.299805%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.004944%, 17.599487%, 57.299805%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.615845%, 17.599487%, 57.299805%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.22522%, 17.599487%, 57.299805%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.014648%, 17.778015%, 57.299805%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.823914%, 17.977905%, 57.299805%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.424133%, 17.999268%, 57.299805%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.183044%, 17.999268%, 57.299805%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.972473%, 17.999268%, 57.299805%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.581848%, 17.999268%, 57.299805%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.192749%, 17.999268%, 57.299805%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.806702%, 17.999268%, 57.299805%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.466431%, 18.186951%, 57.299805%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.130737%, 18.386841%, 57.299805%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.697388%, 18.399048%, 57.299805%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.260986%, 18.399048%, 57.299805%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.876465%, 18.399048%, 57.299805%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.490417%, 18.399048%, 57.299805%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.10437%, 18.59436%, 57.299805%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.713745%, 18.79425%, 57.299805%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.32312%, 18.798828%, 57.299805%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.112549%, 18.798828%, 57.299805%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.921814%, 18.798828%, 57.299805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.522034%, 18.798828%, 57.299805%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.280945%, 18.798828%, 57.299805%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.068848%, 18.811035%, 57.299805%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.679749%, 19.010925%, 57.299805%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.342529%, 19.198608%, 57.299805%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.199097%, 19.198608%, 57.299805%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.00531%, 19.198608%, 57.299805%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.616211%, 19.198608%, 57.299805%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.410217%, 19.198608%, 57.299805%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.219482%, 19.198608%, 57.299805%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.844116%, 19.198608%, 57.299805%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.422974%, 19.218445%, 57.299805%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.183411%, 19.419861%, 57.299805%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.972839%, 19.599915%, 57.299805%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.586792%, 19.599915%, 57.299805%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.200745%, 19.599915%, 57.299805%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.81012%, 19.599915%, 57.299805%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.419495%, 19.599915%, 57.299805%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.033447%, 19.776917%, 57.299805%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.651978%, 19.976807%, 57.299805%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.26593%, 19.999695%, 57.299805%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.875305%, 19.999695%, 57.299805%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.489258%, 19.999695%, 57.299805%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.10321%, 19.999695%, 57.299805%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.712585%, 20.19043%, 57.299805%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.508118%, 20.39032%, 57.299805%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.317383%, 20.399475%, 57.299805%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.942017%, 20.399475%, 57.299805%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.5224%, 20.399475%, 57.299805%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.281311%, 20.399475%, 57.299805%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.069214%, 20.399475%, 57.299805%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.686218%, 20.407104%, 57.299805%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.495483%, 20.606995%, 57.299805%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.297119%, 20.799255%, 57.299805%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.906494%, 20.799255%, 57.299805%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.555542%, 20.799255%, 57.299805%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.219849%, 20.799255%, 57.299805%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.844482%, 20.799255%, 57.299805%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.42334%, 20.999146%, 57.299805%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.183777%, 21.199036%, 57.299805%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.973206%, 21.199036%, 57.299805%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.588684%, 21.199036%, 57.299805%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.397949%, 21.199036%, 57.299805%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.201111%, 21.199036%, 57.299805%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.810486%, 21.199036%, 57.299805%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.419861%, 21.199036%, 57.299805%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.210815%, 21.382141%, 57.299805%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.020081%, 21.582031%, 57.299805%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.6203%, 21.598816%, 57.299805%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.380737%, 21.598816%, 57.299805%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.167114%, 21.598816%, 57.299805%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.778015%, 21.598816%, 57.299805%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.442322%, 21.598816%, 57.299805%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.298889%, 21.598816%, 57.299805%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b0a6d4f713"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 71.417969 39.46875 L 120.460938 39.46875 L 120.460938 110.558594 L 71.417969 110.558594 Z M 71.417969 39.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3ae82d968"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.046875 79.191406 C 71.566406 80.34375 71.367188 80.820312 71.4375 83.011719 C 71.5 84.90625 71.835938 85.882812 72.261719 87.125 C 72.6875 88.359375 73.171875 89.761719 73.460938 92.132812 C 73.601562 93.308594 73.644531 94.515625 73.605469 95.742188 C 75.171875 96.609375 77.070312 97.273438 79.347656 97.769531 C 96.375 101.496094 91.371094 110.558594 91.371094 110.558594 C 104.15625 98.730469 95.324219 91.253906 91.691406 88.695312 C 87.253906 85.570312 82.800781 83.828125 79.308594 82.855469 C 89.664062 83.890625 100.019531 80.996094 105.953125 72.460938 C 115.289062 59.03125 120.460938 39.46875 120.460938 39.46875 C 120.460938 39.46875 113.488281 49.773438 92.917969 53.988281 C 91.816406 54.214844 90.777344 54.453125 89.792969 54.703125 C 88.351562 55.652344 86.652344 56.871094 84.902344 58.335938 C 80.671875 61.871094 75.246094 67.636719 73.429688 75 C 72.902344 77.136719 72.40625 78.324219 72.046875 79.191406 Z M 72.046875 79.191406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df398cb813"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 72.046875 79.191406 C 71.566406 80.34375 71.367188 80.820312 71.4375 83.011719 C 71.5 84.90625 71.835938 85.882812 72.261719 87.125 C 72.6875 88.359375 73.171875 89.761719 73.460938 92.132812 C 73.601562 93.308594 73.644531 94.515625 73.605469 95.742188 C 75.171875 96.609375 77.070312 97.273438 79.347656 97.769531 C 96.375 101.496094 91.371094 110.558594 91.371094 110.558594 C 104.15625 98.730469 95.324219 91.253906 91.691406 88.695312 C 87.253906 85.570312 82.800781 83.828125 79.308594 82.855469 C 89.664062 83.890625 100.019531 80.996094 105.953125 72.460938 C 115.289062 59.03125 120.460938 39.46875 120.460938 39.46875 C 120.460938 39.46875 113.488281 49.773438 92.917969 53.988281 C 91.816406 54.214844 90.777344 54.453125 89.792969 54.703125 C 88.351562 55.652344 86.652344 56.871094 84.902344 58.335938 C 80.671875 61.871094 75.246094 67.636719 73.429688 75 C 72.902344 77.136719 72.40625 78.324219 72.046875 79.191406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -7.89257e-7,
    gradientTransform: "matrix(-49.034507, 0, 0, 48.751502, 120.45913, 75.013383)",
    y1: 0,
    x2: 1.000129,
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    id: "4574d76a8f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.598633%, 11.799622%, 57.998657%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.398743%, 11.799622%, 57.998657%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.198853%, 11.799622%, 57.998657%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.863159%, 11.999512%, 57.998657%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.528992%, 12.199402%, 57.998657%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.29248%, 12.199402%, 57.998657%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.057495%, 12.199402%, 57.998657%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.86676%, 12.199402%, 57.998657%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.286926%, 12.199402%, 57.798767%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.896301%, 12.199402%, 57.598877%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.697937%, 12.199402%, 57.598877%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.499573%, 12.199402%, 57.598877%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.116577%, 12.199402%, 57.598877%)",
    offset: 0.0507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.735107%, 12.199402%, 57.598877%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.544373%, 12.199402%, 57.598877%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.926392%, 12.208557%, 57.598877%)",
    offset: 0.0664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.499146%, 12.217712%, 57.598877%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.296204%, 12.358093%, 57.598877%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.093262%, 12.5%, 57.598877%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.896423%, 12.5%, 57.598877%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.699585%, 12.5%, 57.598877%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.365417%, 12.5%, 57.598877%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.032776%, 12.5%, 57.598877%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.842041%, 12.5%, 57.598877%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.225586%, 12.5%, 57.598877%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.799866%, 12.5%, 57.598877%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.595398%, 12.5%, 57.598877%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.39093%, 12.5%, 57.598877%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.194092%, 12.5%, 57.598877%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.998779%, 12.5%, 57.598877%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.614258%, 12.69989%, 57.598877%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.229736%, 12.89978%, 57.598877%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.014587%, 12.89978%, 57.598877%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.799438%, 12.89978%, 57.598877%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.399658%, 12.89978%, 57.598877%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.999878%, 12.89978%, 57.598877%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.79541%, 12.89978%, 57.598877%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.590942%, 12.89978%, 57.598877%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.444458%, 12.89978%, 57.598877%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.913452%, 12.89978%, 57.598877%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.527405%, 12.89978%, 57.598877%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.312256%, 12.89978%, 57.598877%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.098633%, 12.89978%, 57.598877%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.732422%, 13.09967%, 57.598877%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.366211%, 13.299561%, 57.598877%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.125122%, 13.299561%, 57.598877%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.885559%, 13.299561%, 57.598877%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.494934%, 13.299561%, 57.598877%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.104309%, 13.299561%, 57.598877%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.913574%, 13.299561%, 57.598877%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.510742%, 13.299561%, 57.598877%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.298645%, 13.299561%, 57.598877%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.930908%, 13.299561%, 57.598877%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.563171%, 13.299561%, 57.598877%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.372437%, 13.499451%, 57.598877%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.181702%, 13.699341%, 57.598877%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.791077%, 13.699341%, 57.598877%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.401978%, 13.699341%, 57.598877%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.211243%, 13.699341%, 57.598877%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.809937%, 13.699341%, 57.598877%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.599365%, 13.699341%, 57.598877%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.228577%, 13.699341%, 57.598877%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.859314%, 13.699341%, 57.598877%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.618225%, 13.699341%, 57.598877%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.378662%, 13.699341%, 57.598877%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.988037%, 13.899231%, 57.598877%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.598938%, 14.099121%, 57.598877%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.408203%, 14.099121%, 57.598877%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.87262%, 14.099121%, 57.598877%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.527771%, 14.099121%, 57.598877%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.341614%, 14.099121%, 57.598877%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.928101%, 14.099121%, 57.598877%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.699219%, 14.099121%, 57.598877%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.297913%, 14.099121%, 57.598877%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.896606%, 14.099121%, 57.598877%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.698242%, 14.291382%, 57.598877%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.499878%, 14.483643%, 57.598877%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.116882%, 14.491272%, 57.598877%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.735413%, 14.498901%, 57.598877%)",
    offset: 0.335937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.544678%, 14.498901%, 57.598877%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.963318%, 14.498901%, 57.598877%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.574219%, 14.498901%, 57.598877%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.33313%, 14.498901%, 57.449341%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.093567%, 14.498901%, 57.299805%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.896729%, 14.498901%, 57.299805%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.69989%, 14.498901%, 57.299805%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.365723%, 14.698792%, 57.299805%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.031555%, 14.898682%, 57.299805%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.84082%, 14.898682%, 57.299805%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.260986%, 14.898682%, 57.299805%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.870361%, 14.898682%, 57.299805%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.629272%, 14.898682%, 57.299805%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.389709%, 14.898682%, 57.299805%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.194397%, 14.898682%, 57.299805%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.613037%, 15.083313%, 57.299805%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.228516%, 15.26947%, 57.299805%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.013367%, 15.284729%, 57.299805%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.799744%, 15.299988%, 57.299805%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.433533%, 15.299988%, 57.299805%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.067322%, 15.299988%, 57.299805%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.876587%, 15.299988%, 57.299805%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.296753%, 15.299988%, 57.299805%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.906128%, 15.299988%, 57.299805%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.715393%, 15.299988%, 57.299805%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.312561%, 15.499878%, 57.299805%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.098938%, 15.699768%, 57.299805%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.731201%, 15.699768%, 57.299805%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.36499%, 15.699768%, 57.299805%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.131531%, 15.699768%, 57.299805%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.899597%, 15.699768%, 57.299805%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.501343%, 15.699768%, 57.299805%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.104614%, 15.699768%, 57.299805%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.913879%, 15.699768%, 57.299805%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.33252%, 15.899658%, 57.299805%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.94342%, 16.099548%, 57.299805%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.752686%, 16.099548%, 57.299805%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.380371%, 16.099548%, 57.299805%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.800537%, 16.099548%, 57.299805%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.402283%, 16.099548%, 57.299805%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.200867%, 16.099548%, 57.299805%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.999451%, 16.099548%, 57.299805%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.619507%, 16.278076%, 57.299805%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.239563%, 16.45813%, 57.299805%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.048828%, 16.477966%, 57.299805%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.468994%, 16.499329%, 57.299805%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.078369%, 16.499329%, 57.299805%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.887634%, 16.499329%, 57.299805%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.448181%, 16.499329%, 57.299805%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 16.499329%, 57.299805%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.86377%, 16.699219%, 57.299805%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.528076%, 16.899109%, 57.299805%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.341919%, 16.899109%, 57.299805%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.765137%, 16.899109%, 57.299805%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.376038%, 16.899109%, 57.299805%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.185303%, 16.899109%, 57.299805%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.747375%, 16.899109%, 57.299805%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.498657%, 16.899109%, 57.299805%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.115662%, 17.098999%, 57.299805%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.734192%, 17.298889%, 57.299805%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.515991%, 17.298889%, 57.299805%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.299316%, 17.298889%, 57.299805%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.936157%, 17.298889%, 57.299805%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.572998%, 17.298889%, 57.299805%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.382263%, 17.298889%, 57.299805%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.802429%, 17.442322%, 57.299805%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.411804%, 17.58728%, 57.299805%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.221069%, 17.593384%, 57.299805%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.815186%, 17.599487%, 57.299805%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.598511%, 17.599487%, 57.299805%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.233826%, 17.599487%, 57.299805%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.870667%, 17.599487%, 57.299805%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.634155%, 17.599487%, 57.299805%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.39917%, 17.599487%, 57.299805%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.054321%, 17.799377%, 57.299805%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.709473%, 17.999268%, 57.299805%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.468384%, 17.999268%, 57.299805%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.228821%, 17.999268%, 57.299805%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.838196%, 17.999268%, 57.299805%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.447571%, 17.999268%, 57.299805%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.256836%, 17.999268%, 57.299805%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.715149%, 18.154907%, 57.299805%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.364197%, 18.312073%, 57.299805%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.184143%, 18.354797%, 57.299805%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.752319%, 18.399048%, 57.299805%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.499023%, 18.399048%, 57.299805%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.122131%, 18.399048%, 57.299805%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.745239%, 18.399048%, 57.299805%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.522461%, 18.399048%, 57.299805%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.299683%, 18.399048%, 57.299805%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.941101%, 18.598938%, 57.299805%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.584045%, 18.798828%, 57.299805%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.393311%, 18.798828%, 57.299805%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.7677%, 18.798828%, 57.299805%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.331299%, 18.798828%, 57.299805%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.135986%, 18.798828%, 57.299805%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.720947%, 18.998718%, 57.299805%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.499695%, 19.198608%, 57.299805%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.189941%, 19.198608%, 57.299805%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.881714%, 19.198608%, 57.299805%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.640625%, 19.198608%, 57.299805%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.399536%, 19.198608%, 57.299805%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.059265%, 19.198608%, 57.299805%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.72052%, 19.198608%, 57.299805%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.479431%, 19.378662%, 57.299805%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.239868%, 19.558716%, 57.299805%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.849243%, 19.578552%, 57.299805%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.458618%, 19.599915%, 57.299805%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.267883%, 19.599915%, 57.299805%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.839111%, 19.599915%, 57.299805%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.599548%, 19.599915%, 57.299805%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.257751%, 19.740295%, 57.299805%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.91748%, 19.880676%, 57.299805%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.708435%, 19.940186%, 57.299805%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.49939%, 19.999695%, 57.299805%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.127075%, 19.999695%, 57.299805%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.756287%, 19.999695%, 57.299805%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.565552%, 19.999695%, 57.299805%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.984192%, 20.150757%, 57.299805%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.595093%, 20.303345%, 57.299805%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.404358%, 20.350647%, 57.299805%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.95575%, 20.399475%, 57.299805%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.699402%, 20.399475%, 57.299805%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.325562%, 20.399475%, 57.299805%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.953247%, 20.399475%, 57.299805%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.725891%, 20.562744%, 57.299805%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.498535%, 20.726013%, 57.299805%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.144531%, 20.762634%, 57.299805%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.792053%, 20.799255%, 57.299805%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.637939%, 20.799255%, 57.299805%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.106934%, 20.799255%, 57.299805%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.731567%, 20.799255%, 57.299805%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.490479%, 20.973206%, 57.299805%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.250916%, 21.148682%, 57.299805%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.860291%, 21.173096%, 57.299805%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.469666%, 21.199036%, 57.299805%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.278931%, 21.199036%, 57.299805%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.844055%, 21.199036%, 57.299805%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.599915%, 21.199036%, 57.299805%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.264221%, 21.398926%, 57.299805%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.928528%, 21.598816%, 57.299805%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.663025%, 21.598816%, 57.299805%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.399048%, 21.598816%, 57.299805%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.032837%, 21.598816%, 57.299805%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.666626%, 21.598816%, 57.299805%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.515564%, 21.598816%, 57.299805%)",
    offset: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -15,
    height: 179.999997,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#047a8d2dc0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7b53f99646)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#859441fd75)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f21dd8c524)",
    d: "M 8.789062 39.46875 L 8.789062 110.558594 L 57.828125 110.558594 L 57.828125 39.46875 Z M 8.789062 39.46875 ",
    fillRule: "nonzero"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17d92195a5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7fdee93d7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96c8ed1f80)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#86018bbafc)",
    d: "M 70.25 54.320312 L 59 54.320312 L 59 65.507812 L 70.25 65.507812 Z M 70.25 54.320312 ",
    fillRule: "nonzero"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fc8b964002)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d6e7f88e6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d6799346d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#0821a32fe1)",
    d: "M 93.054688 50.464844 L 36.191406 50.464844 L 36.191406 118.214844 L 93.054688 118.214844 Z M 93.054688 50.464844 ",
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b0a6d4f713)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b3ae82d968)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df398cb813)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4574d76a8f)",
    d: "M 120.460938 39.46875 L 120.460938 110.558594 L 71.417969 110.558594 L 71.417969 39.46875 Z M 120.460938 39.46875 ",
    fillRule: "nonzero"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.853666, 0, 0, 0.853666, 122.744418, 41.434221)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 29.054038 28.781365 C 28.541543 26.969328 27.589766 25.546238 26.194132 24.516672 C 24.798497 23.48253 23.045947 22.970035 20.93648 22.970035 C 17.971328 22.970035 15.573583 24.063663 13.734091 26.260071 C 11.903751 28.442752 10.988581 31.55433 10.988581 35.594806 C 10.988581 39.644434 11.890023 42.774316 13.692908 44.984451 C 15.495793 47.190011 17.939297 48.288215 21.018845 48.288215 C 23.7369 48.288215 25.878398 47.578959 27.429611 46.155869 C 28.989976 44.73278 29.795326 42.829226 29.84566 40.436056 L 21.522188 40.436056 L 21.522188 34.267809 L 37.743578 34.267809 L 37.743578 39.145666 C 37.743578 42.536371 37.020594 45.46034 35.583777 47.912996 C 34.142384 50.365651 32.165617 52.250902 29.653475 53.568747 C 27.136757 54.87744 24.244819 55.531787 20.977662 55.531787 C 17.344437 55.531787 14.155069 54.731013 11.404983 53.129465 C 8.659473 51.51419 6.517975 49.226265 4.980489 46.261114 C 3.456731 43.286811 2.692564 39.754254 2.692564 35.658868 C 2.692564 31.481116 3.488762 27.907377 5.085733 24.933074 C 6.687281 21.94962 8.856234 19.670846 11.588017 18.092178 C 14.328951 16.513509 17.399347 15.721887 20.808356 15.721887 C 23.732324 15.721887 26.377166 16.280141 28.742881 17.387497 C 31.117747 18.499429 33.057908 20.036914 34.567938 22.00453 C 36.087121 23.962994 37.020594 26.223464 37.37751 28.781365 Z M 43.88437 55.000988 L 43.88437 16.257262 L 52.079718 16.257262 L 52.079718 48.251609 L 68.68548 48.251609 L 68.68548 55.000988 Z M 109.707979 35.635989 C 109.707979 39.859499 108.911781 43.451541 107.314809 46.416693 C 105.717838 49.372692 103.55346 51.633162 100.812526 53.193527 C 98.080743 54.753892 94.99662 55.531787 91.564732 55.531787 C 88.123692 55.531787 85.030418 54.753892 82.294059 53.193527 C 79.562276 51.62401 77.402475 49.354389 75.814655 46.389237 C 74.226835 43.414935 73.435212 39.832044 73.435212 35.635989 C 73.435212 31.403327 74.226835 27.811284 75.814655 24.855285 C 77.402475 21.890134 79.562276 19.625088 82.294059 18.064723 C 85.030418 16.504358 88.123692 15.721887 91.564732 15.721887 C 94.99662 15.721887 98.080743 16.504358 100.812526 18.064723 C 103.55346 19.625088 105.717838 21.890134 107.314809 24.855285 C 108.911781 27.811284 109.707979 31.403327 109.707979 35.635989 Z M 101.411962 35.635989 C 101.411962 31.517723 100.515096 28.37869 98.716786 26.218888 C 96.932205 24.049935 94.548187 22.970035 91.564732 22.970035 C 88.590429 22.970035 86.206411 24.049935 84.412678 26.218888 C 82.628096 28.37869 81.731229 31.517723 81.731229 35.635989 C 81.731229 39.726799 82.628096 42.861257 84.412678 45.039362 C 86.206411 47.203739 88.590429 48.288215 91.564732 48.288215 C 94.548187 48.288215 96.932205 47.203739 98.716786 45.039362 C 100.515096 42.861257 101.411962 39.726799 101.411962 35.635989 Z M 115.76183 55.000988 L 115.76183 16.257262 L 131.04517 16.257262 C 135.451714 16.257262 138.865299 17.4058 141.295075 19.702877 C 143.720276 21.999954 144.932876 25.07035 144.932876 28.909488 C 144.932876 31.563482 144.347168 33.833104 143.166598 35.713778 C 141.986029 37.585301 140.292964 38.994663 138.082828 39.941864 L 146.314783 55.000988 L 137.272903 55.000988 L 129.928663 41.264285 L 123.957178 41.264285 L 123.957178 55.000988 Z M 123.957178 34.684212 L 129.51226 34.684212 C 134.1659 34.684212 136.495008 32.762355 136.495008 28.909488 C 136.495008 24.942226 134.152173 22.956307 129.471078 22.956307 L 123.957178 22.956307 Z M 158.9121 16.257262 L 158.9121 55.000988 L 150.721327 55.000988 L 150.721327 16.257262 Z M 201.25702 35.635989 C 201.25702 39.859499 200.460822 43.451541 198.86385 46.416693 C 197.271455 49.372692 195.102501 51.633162 192.361567 53.193527 C 189.629784 54.753892 186.550237 55.531787 183.113773 55.531787 C 179.672733 55.531787 176.584034 54.753892 173.8431 53.193527 C 171.111317 51.62401 168.951516 49.354389 167.368271 46.389237 C 165.780451 43.414935 164.984253 39.832044 164.984253 35.635989 C 164.984253 31.403327 165.780451 27.811284 167.368271 24.855285 C 168.951516 21.890134 171.111317 19.625088 173.8431 18.064723 C 176.584034 16.504358 179.672733 15.721887 183.113773 15.721887 C 186.550237 15.721887 189.629784 16.504358 192.361567 18.064723 C 195.102501 19.625088 197.271455 21.890134 198.86385 24.855285 C 200.460822 27.811284 201.25702 31.403327 201.25702 35.635989 Z M 192.961003 35.635989 C 192.961003 31.517723 192.064137 28.37869 190.270403 26.218888 C 188.481246 24.049935 186.097228 22.970035 183.113773 22.970035 C 180.144046 22.970035 177.755452 24.049935 175.961719 26.218888 C 174.177137 28.37869 173.284846 31.517723 173.284846 35.635989 C 173.284846 39.726799 174.177137 42.861257 175.961719 45.039362 C 177.755452 47.203739 180.144046 48.288215 183.113773 48.288215 C 186.097228 48.288215 188.481246 47.203739 190.270403 45.039362 C 192.064137 42.861257 192.961003 39.726799 192.961003 35.635989 Z M 231.297479 16.257262 L 239.437917 16.257262 L 239.437917 41.877449 C 239.437917 44.801417 238.746963 47.276952 237.369632 49.317782 C 236.001453 51.354035 234.107051 52.900673 231.686426 53.957694 C 229.274953 55.019291 226.506563 55.545514 223.376682 55.545514 C 220.2468 55.545514 217.473834 55.019291 215.05321 53.957694 C 212.632585 52.900673 210.738183 51.354035 209.370003 49.317782 C 207.997248 47.276952 207.315446 44.801417 207.315446 41.877449 L 207.315446 16.257262 L 215.506219 16.257262 L 215.506219 41.593746 C 215.506219 43.652879 216.252082 45.281882 217.74381 46.467027 C 219.235537 47.656748 221.111636 48.251609 223.376682 48.251609 C 225.673759 48.251609 227.568161 47.656748 229.059888 46.467027 C 230.551615 45.281882 231.297479 43.652879 231.297479 41.593746 Z M 267.181298 27.404034 C 267.02572 25.8757 266.371373 24.69513 265.218259 23.853174 C 264.065144 23.002065 262.513931 22.576511 260.564619 22.576511 C 258.560396 22.576511 257.02291 22.988338 255.947586 23.811991 C 254.872261 24.626492 254.33231 25.660635 254.33231 26.909842 C 254.309431 28.296325 254.899716 29.344194 256.116892 30.053451 C 257.338644 30.767284 258.789189 31.316386 260.473102 31.705333 L 263.946172 32.538138 C 266.188339 33.050633 268.18341 33.787345 269.926809 34.75285 C 271.67936 35.704626 273.052115 36.93553 274.04965 38.445561 C 275.056337 39.941864 275.559681 41.772204 275.559681 43.932006 C 275.550529 47.47829 274.223532 50.30159 271.578691 52.397329 C 268.933849 54.497644 265.25029 55.545514 260.523436 55.545514 C 255.814886 55.545514 252.062688 54.474765 249.262268 52.333267 C 246.470999 50.191769 245.020455 47.029856 244.919786 42.838377 L 252.840583 42.838377 C 252.977859 44.783114 253.746601 46.24281 255.142236 47.222042 C 256.53787 48.192123 258.299573 48.677163 260.431919 48.677163 C 262.513931 48.677163 264.174965 48.242457 265.41502 47.363894 C 266.655076 46.480754 267.281967 45.332216 267.300271 43.918278 C 267.281967 42.600433 266.70541 41.593746 265.570599 40.889065 C 264.435788 40.179808 262.811361 39.57122 260.70647 39.067877 L 256.492112 38.015431 C 253.224954 37.232961 250.644175 35.992905 248.754349 34.295265 C 246.864522 32.588472 245.921897 30.305123 245.931049 27.454368 C 245.921897 25.111533 246.553364 23.061552 247.816299 21.304425 C 249.08381 19.542723 250.827209 18.174543 253.046496 17.195311 C 255.265784 16.211503 257.787077 15.721887 260.614953 15.721887 C 263.493163 15.721887 266.009881 16.216079 268.16053 17.204463 C 270.31118 18.188271 271.981366 19.55645 273.180238 21.318153 C 274.374535 23.066127 274.996851 25.097805 275.038034 27.404034 Z M 267.181298 27.404034 ",
    stroke: "#002b4b",
    strokeWidth: 1.664784,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.744418, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 24.796875 -22.375 C 24.359375 -23.925781 23.546875 -25.140625 22.359375 -26.015625 C 21.171875 -26.898438 19.675781 -27.34375 17.875 -27.34375 C 15.34375 -27.34375 13.289062 -26.40625 11.71875 -24.53125 C 10.15625 -22.664062 9.375 -20.007812 9.375 -16.5625 C 9.375 -13.113281 10.144531 -10.445312 11.6875 -8.5625 C 13.226562 -6.675781 15.3125 -5.734375 17.9375 -5.734375 C 20.257812 -5.734375 22.085938 -6.335938 23.421875 -7.546875 C 24.753906 -8.753906 25.441406 -10.382812 25.484375 -12.4375 L 18.375 -12.4375 L 18.375 -17.703125 L 32.21875 -17.703125 L 32.21875 -13.53125 C 32.21875 -10.632812 31.601562 -8.140625 30.375 -6.046875 C 29.144531 -3.953125 27.457031 -2.34375 25.3125 -1.21875 C 23.164062 -0.101562 20.695312 0.453125 17.90625 0.453125 C 14.800781 0.453125 12.078125 -0.234375 9.734375 -1.609375 C 7.390625 -2.984375 5.5625 -4.9375 4.25 -7.46875 C 2.945312 -10 2.296875 -13.007812 2.296875 -16.5 C 2.296875 -20.070312 2.976562 -23.128906 4.34375 -25.671875 C 5.707031 -28.210938 7.554688 -30.15625 9.890625 -31.5 C 12.234375 -32.84375 14.859375 -33.515625 17.765625 -33.515625 C 20.253906 -33.515625 22.507812 -33.039062 24.53125 -32.09375 C 26.5625 -31.144531 28.222656 -29.832031 29.515625 -28.15625 C 30.804688 -26.488281 31.601562 -24.5625 31.90625 -22.375 Z M 24.796875 -22.375 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.332263, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.875 0 L 2.875 -33.0625 L 9.859375 -33.0625 L 9.859375 -5.765625 L 24.046875 -5.765625 L 24.046875 0 Z M 2.875 0 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.135899, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.265625 -16.53125 C 33.265625 -12.925781 32.582031 -9.859375 31.21875 -7.328125 C 29.851562 -4.796875 28.003906 -2.863281 25.671875 -1.53125 C 23.335938 -0.207031 20.707031 0.453125 17.78125 0.453125 C 14.84375 0.453125 12.203125 -0.210938 9.859375 -1.546875 C 7.523438 -2.878906 5.679688 -4.8125 4.328125 -7.34375 C 2.972656 -9.882812 2.296875 -12.945312 2.296875 -16.53125 C 2.296875 -20.132812 2.972656 -23.203125 4.328125 -25.734375 C 5.679688 -28.265625 7.523438 -30.191406 9.859375 -31.515625 C 12.203125 -32.847656 14.84375 -33.515625 17.78125 -33.515625 C 20.707031 -33.515625 23.335938 -32.847656 25.671875 -31.515625 C 28.003906 -30.191406 29.851562 -28.265625 31.21875 -25.734375 C 32.582031 -23.203125 33.265625 -20.132812 33.265625 -16.53125 Z M 26.171875 -16.53125 C 26.171875 -20.039062 25.40625 -22.71875 23.875 -24.5625 C 22.351562 -26.414062 20.320312 -27.34375 17.78125 -27.34375 C 15.238281 -27.34375 13.203125 -26.414062 11.671875 -24.5625 C 10.140625 -22.71875 9.375 -20.039062 9.375 -16.53125 C 9.375 -13.03125 10.140625 -10.351562 11.671875 -8.5 C 13.203125 -6.65625 15.238281 -5.734375 17.78125 -5.734375 C 20.320312 -5.734375 22.351562 -6.65625 23.875 -8.5 C 25.40625 -10.351562 26.171875 -13.03125 26.171875 -16.53125 Z M 26.171875 -16.53125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.692599, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.875 0 L 2.875 -33.0625 L 15.921875 -33.0625 C 19.679688 -33.0625 22.59375 -32.082031 24.65625 -30.125 C 26.726562 -28.164062 27.765625 -25.546875 27.765625 -22.265625 C 27.765625 -20.003906 27.257812 -18.070312 26.25 -16.46875 C 25.25 -14.863281 23.804688 -13.660156 21.921875 -12.859375 L 28.953125 0 L 21.234375 0 L 14.96875 -11.71875 L 9.859375 -11.71875 L 9.859375 0 Z M 9.859375 -17.34375 L 14.609375 -17.34375 C 18.585938 -17.34375 20.578125 -18.984375 20.578125 -22.265625 C 20.578125 -25.660156 18.578125 -27.359375 14.578125 -27.359375 L 9.859375 -27.359375 Z M 9.859375 -17.34375 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(248.533097, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.859375 -33.0625 L 9.859375 0 L 2.875 0 L 2.875 -33.0625 Z M 9.859375 -33.0625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.289585, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 33.265625 -16.53125 C 33.265625 -12.925781 32.582031 -9.859375 31.21875 -7.328125 C 29.851562 -4.796875 28.003906 -2.863281 25.671875 -1.53125 C 23.335938 -0.207031 20.707031 0.453125 17.78125 0.453125 C 14.84375 0.453125 12.203125 -0.210938 9.859375 -1.546875 C 7.523438 -2.878906 5.679688 -4.8125 4.328125 -7.34375 C 2.972656 -9.882812 2.296875 -12.945312 2.296875 -16.53125 C 2.296875 -20.132812 2.972656 -23.203125 4.328125 -25.734375 C 5.679688 -28.265625 7.523438 -30.191406 9.859375 -31.515625 C 12.203125 -32.847656 14.84375 -33.515625 17.78125 -33.515625 C 20.707031 -33.515625 23.335938 -32.847656 25.671875 -31.515625 C 28.003906 -30.191406 29.851562 -28.265625 31.21875 -25.734375 C 32.582031 -23.203125 33.265625 -20.132812 33.265625 -16.53125 Z M 26.171875 -16.53125 C 26.171875 -20.039062 25.40625 -22.71875 23.875 -24.5625 C 22.351562 -26.414062 20.320312 -27.34375 17.78125 -27.34375 C 15.238281 -27.34375 13.203125 -26.414062 11.671875 -24.5625 C 10.140625 -22.71875 9.375 -20.039062 9.375 -16.53125 C 9.375 -13.03125 10.140625 -10.351562 11.671875 -8.5 C 13.203125 -6.65625 15.238281 -5.734375 17.78125 -5.734375 C 20.320312 -5.734375 22.351562 -6.65625 23.875 -8.5 C 25.40625 -10.351562 26.171875 -13.03125 26.171875 -16.53125 Z M 26.171875 -16.53125 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.846285, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 23.34375 -33.0625 L 30.296875 -33.0625 L 30.296875 -11.203125 C 30.296875 -8.703125 29.707031 -6.582031 28.53125 -4.84375 C 27.351562 -3.113281 25.734375 -1.796875 23.671875 -0.890625 C 21.617188 0.015625 19.253906 0.46875 16.578125 0.46875 C 13.910156 0.46875 11.539062 0.015625 9.46875 -0.890625 C 7.40625 -1.796875 5.789062 -3.113281 4.625 -4.84375 C 3.457031 -6.582031 2.875 -8.703125 2.875 -11.203125 L 2.875 -33.0625 L 9.859375 -33.0625 L 9.859375 -11.453125 C 9.859375 -9.679688 10.492188 -8.289062 11.765625 -7.28125 C 13.046875 -6.269531 14.648438 -5.765625 16.578125 -5.765625 C 18.535156 -5.765625 20.148438 -6.269531 21.421875 -7.28125 C 22.703125 -8.289062 23.34375 -9.679688 23.34375 -11.453125 Z M 23.34375 -33.0625 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(330.013159, 88.385875)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.8125 -23.5625 C 20.6875 -24.863281 20.128906 -25.875 19.140625 -26.59375 C 18.160156 -27.3125 16.832031 -27.671875 15.15625 -27.671875 C 13.445312 -27.671875 12.132812 -27.320312 11.21875 -26.625 C 10.300781 -25.925781 9.84375 -25.046875 9.84375 -23.984375 C 9.820312 -22.796875 10.332031 -21.894531 11.375 -21.28125 C 12.414062 -20.675781 13.648438 -20.207031 15.078125 -19.875 L 18.046875 -19.171875 C 19.960938 -18.734375 21.664062 -18.101562 23.15625 -17.28125 C 24.65625 -16.46875 25.832031 -15.414062 26.6875 -14.125 C 27.539062 -12.84375 27.96875 -11.285156 27.96875 -9.453125 C 27.957031 -6.421875 26.820312 -4.007812 24.5625 -2.21875 C 22.3125 -0.425781 19.164062 0.46875 15.125 0.46875 C 11.113281 0.46875 7.910156 -0.441406 5.515625 -2.265625 C 3.128906 -4.097656 1.894531 -6.800781 1.8125 -10.375 L 8.578125 -10.375 C 8.691406 -8.71875 9.34375 -7.472656 10.53125 -6.640625 C 11.71875 -5.804688 13.222656 -5.390625 15.046875 -5.390625 C 16.828125 -5.390625 18.242188 -5.765625 19.296875 -6.515625 C 20.359375 -7.273438 20.894531 -8.257812 20.90625 -9.46875 C 20.894531 -10.582031 20.40625 -11.441406 19.4375 -12.046875 C 18.46875 -12.648438 17.085938 -13.164062 15.296875 -13.59375 L 11.6875 -14.5 C 8.90625 -15.164062 6.707031 -16.222656 5.09375 -17.671875 C 3.476562 -19.128906 2.675781 -21.078125 2.6875 -23.515625 C 2.675781 -25.515625 3.207031 -27.265625 4.28125 -28.765625 C 5.363281 -30.265625 6.851562 -31.429688 8.75 -32.265625 C 10.644531 -33.097656 12.796875 -33.515625 15.203125 -33.515625 C 17.660156 -33.515625 19.804688 -33.09375 21.640625 -32.25 C 23.472656 -31.414062 24.898438 -30.25 25.921875 -28.75 C 26.953125 -27.257812 27.484375 -25.53125 27.515625 -23.5625 Z M 20.8125 -23.5625 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128.188664, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.15625 0 L 0.890625 0 L 0.890625 -7.359375 L 3.265625 -7.359375 C 3.972656 -7.359375 4.578125 -7.207031 5.078125 -6.90625 C 5.585938 -6.613281 5.976562 -6.191406 6.25 -5.640625 C 6.519531 -5.097656 6.65625 -4.445312 6.65625 -3.6875 C 6.65625 -2.925781 6.519531 -2.269531 6.25 -1.71875 C 5.976562 -1.164062 5.582031 -0.738281 5.0625 -0.4375 C 4.539062 -0.144531 3.90625 0 3.15625 0 Z M 1.78125 -0.796875 L 3.109375 -0.796875 C 4.015625 -0.796875 4.6875 -1.050781 5.125 -1.5625 C 5.570312 -2.082031 5.796875 -2.789062 5.796875 -3.6875 C 5.796875 -4.582031 5.578125 -5.285156 5.140625 -5.796875 C 4.710938 -6.304688 4.066406 -6.5625 3.203125 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -0.796875 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.28799, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.78125 -7.359375 L 1.78125 0 L 0.890625 0 L 0.890625 -7.359375 Z M 1.78125 -7.359375 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.796484, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.90625 -5.515625 C 4.863281 -5.878906 4.6875 -6.160156 4.375 -6.359375 C 4.070312 -6.554688 3.703125 -6.65625 3.265625 -6.65625 C 2.773438 -6.65625 2.378906 -6.539062 2.078125 -6.3125 C 1.785156 -6.082031 1.640625 -5.789062 1.640625 -5.4375 C 1.640625 -5.175781 1.71875 -4.960938 1.875 -4.796875 C 2.039062 -4.640625 2.234375 -4.515625 2.453125 -4.421875 C 2.671875 -4.335938 2.875 -4.269531 3.0625 -4.21875 L 3.8125 -4.015625 C 4 -3.960938 4.207031 -3.890625 4.4375 -3.796875 C 4.675781 -3.710938 4.90625 -3.59375 5.125 -3.4375 C 5.34375 -3.289062 5.519531 -3.097656 5.65625 -2.859375 C 5.800781 -2.628906 5.875 -2.34375 5.875 -2 C 5.875 -1.601562 5.769531 -1.242188 5.5625 -0.921875 C 5.351562 -0.597656 5.050781 -0.34375 4.65625 -0.15625 C 4.257812 0.03125 3.78125 0.125 3.21875 0.125 C 2.425781 0.125 1.796875 -0.0546875 1.328125 -0.421875 C 0.867188 -0.796875 0.617188 -1.285156 0.578125 -1.890625 L 1.5 -1.890625 C 1.519531 -1.617188 1.609375 -1.390625 1.765625 -1.203125 C 1.929688 -1.023438 2.140625 -0.890625 2.390625 -0.796875 C 2.648438 -0.710938 2.925781 -0.671875 3.21875 -0.671875 C 3.550781 -0.671875 3.851562 -0.726562 4.125 -0.84375 C 4.394531 -0.957031 4.609375 -1.113281 4.765625 -1.3125 C 4.929688 -1.507812 5.015625 -1.742188 5.015625 -2.015625 C 5.015625 -2.253906 4.945312 -2.453125 4.8125 -2.609375 C 4.675781 -2.765625 4.492188 -2.890625 4.265625 -2.984375 C 4.046875 -3.078125 3.804688 -3.160156 3.546875 -3.234375 L 2.640625 -3.484375 C 2.066406 -3.648438 1.613281 -3.882812 1.28125 -4.1875 C 0.945312 -4.5 0.78125 -4.90625 0.78125 -5.40625 C 0.78125 -5.8125 0.890625 -6.164062 1.109375 -6.46875 C 1.335938 -6.78125 1.640625 -7.019531 2.015625 -7.1875 C 2.390625 -7.363281 2.8125 -7.453125 3.28125 -7.453125 C 3.757812 -7.453125 4.179688 -7.367188 4.546875 -7.203125 C 4.921875 -7.035156 5.210938 -6.804688 5.421875 -6.515625 C 5.640625 -6.222656 5.753906 -5.890625 5.765625 -5.515625 Z M 4.90625 -5.515625 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.07807, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 0 L 0.265625 0 L 2.953125 -7.359375 L 3.875 -7.359375 L 6.578125 0 L 5.640625 0 L 4.90625 -2.078125 L 1.9375 -2.078125 Z M 2.21875 -2.875 L 4.625 -2.875 L 3.453125 -6.1875 L 3.390625 -6.1875 Z M 2.21875 -2.875 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.74701, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 3.453125 -7.359375 C 3.972656 -7.359375 4.398438 -7.269531 4.734375 -7.09375 C 5.066406 -6.914062 5.3125 -6.675781 5.46875 -6.375 C 5.632812 -6.082031 5.71875 -5.757812 5.71875 -5.40625 C 5.71875 -5.082031 5.660156 -4.816406 5.546875 -4.609375 C 5.429688 -4.410156 5.285156 -4.25 5.109375 -4.125 C 4.929688 -4.007812 4.734375 -3.921875 4.515625 -3.859375 L 4.515625 -3.796875 C 4.742188 -3.773438 4.972656 -3.691406 5.203125 -3.546875 C 5.429688 -3.410156 5.617188 -3.207031 5.765625 -2.9375 C 5.921875 -2.664062 6 -2.335938 6 -1.953125 C 6 -1.585938 5.914062 -1.253906 5.75 -0.953125 C 5.582031 -0.660156 5.316406 -0.425781 4.953125 -0.25 C 4.597656 -0.0820312 4.128906 0 3.546875 0 Z M 1.78125 -0.796875 L 3.546875 -0.796875 C 4.128906 -0.796875 4.539062 -0.90625 4.78125 -1.125 C 5.03125 -1.351562 5.15625 -1.628906 5.15625 -1.953125 C 5.15625 -2.203125 5.09375 -2.429688 4.96875 -2.640625 C 4.84375 -2.859375 4.660156 -3.03125 4.421875 -3.15625 C 4.191406 -3.28125 3.914062 -3.34375 3.59375 -3.34375 L 1.78125 -3.34375 Z M 1.78125 -4.125 L 3.4375 -4.125 C 3.832031 -4.125 4.171875 -4.238281 4.453125 -4.46875 C 4.734375 -4.695312 4.875 -5.007812 4.875 -5.40625 C 4.875 -5.726562 4.757812 -6 4.53125 -6.21875 C 4.300781 -6.445312 3.941406 -6.5625 3.453125 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -4.125 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.157713, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.78125 -7.359375 L 1.78125 0 L 0.890625 0 L 0.890625 -7.359375 Z M 1.78125 -7.359375 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.666208, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 1.78125 -7.359375 L 1.78125 -0.796875 L 5.203125 -0.796875 L 5.203125 0 Z M 0.890625 0 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(186.187439, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.78125 -7.359375 L 1.78125 0 L 0.890625 0 L 0.890625 -7.359375 Z M 1.78125 -7.359375 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.695935, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 -6.5625 L 0.484375 -7.359375 L 6 -7.359375 L 6 -6.5625 L 3.6875 -6.5625 L 3.6875 0 L 2.796875 0 L 2.796875 -6.5625 Z M 0.484375 -6.5625 "
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.020554, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.265625 -7.359375 L 1.28125 -7.359375 L 3.3125 -3.921875 L 3.40625 -3.921875 L 5.4375 -7.359375 L 6.46875 -7.359375 L 3.8125 -3.03125 L 3.8125 0 L 2.921875 0 L 2.921875 -3.03125 Z M 0.265625 -7.359375 "
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(210.574719, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(216.255372, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.90625 -5.515625 C 4.863281 -5.878906 4.6875 -6.160156 4.375 -6.359375 C 4.070312 -6.554688 3.703125 -6.65625 3.265625 -6.65625 C 2.773438 -6.65625 2.378906 -6.539062 2.078125 -6.3125 C 1.785156 -6.082031 1.640625 -5.789062 1.640625 -5.4375 C 1.640625 -5.175781 1.71875 -4.960938 1.875 -4.796875 C 2.039062 -4.640625 2.234375 -4.515625 2.453125 -4.421875 C 2.671875 -4.335938 2.875 -4.269531 3.0625 -4.21875 L 3.8125 -4.015625 C 4 -3.960938 4.207031 -3.890625 4.4375 -3.796875 C 4.675781 -3.710938 4.90625 -3.59375 5.125 -3.4375 C 5.34375 -3.289062 5.519531 -3.097656 5.65625 -2.859375 C 5.800781 -2.628906 5.875 -2.34375 5.875 -2 C 5.875 -1.601562 5.769531 -1.242188 5.5625 -0.921875 C 5.351562 -0.597656 5.050781 -0.34375 4.65625 -0.15625 C 4.257812 0.03125 3.78125 0.125 3.21875 0.125 C 2.425781 0.125 1.796875 -0.0546875 1.328125 -0.421875 C 0.867188 -0.796875 0.617188 -1.285156 0.578125 -1.890625 L 1.5 -1.890625 C 1.519531 -1.617188 1.609375 -1.390625 1.765625 -1.203125 C 1.929688 -1.023438 2.140625 -0.890625 2.390625 -0.796875 C 2.648438 -0.710938 2.925781 -0.671875 3.21875 -0.671875 C 3.550781 -0.671875 3.851562 -0.726562 4.125 -0.84375 C 4.394531 -0.957031 4.609375 -1.113281 4.765625 -1.3125 C 4.929688 -1.507812 5.015625 -1.742188 5.015625 -2.015625 C 5.015625 -2.253906 4.945312 -2.453125 4.8125 -2.609375 C 4.675781 -2.765625 4.492188 -2.890625 4.265625 -2.984375 C 4.046875 -3.078125 3.804688 -3.160156 3.546875 -3.234375 L 2.640625 -3.484375 C 2.066406 -3.648438 1.613281 -3.882812 1.28125 -4.1875 C 0.945312 -4.5 0.78125 -4.90625 0.78125 -5.40625 C 0.78125 -5.8125 0.890625 -6.164062 1.109375 -6.46875 C 1.335938 -6.78125 1.640625 -7.019531 2.015625 -7.1875 C 2.390625 -7.363281 2.8125 -7.453125 3.28125 -7.453125 C 3.757812 -7.453125 4.179688 -7.367188 4.546875 -7.203125 C 4.921875 -7.035156 5.210938 -6.804688 5.421875 -6.515625 C 5.640625 -6.222656 5.753906 -5.890625 5.765625 -5.515625 Z M 4.90625 -5.515625 "
  }))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.536961, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.71875 -7.359375 L 6.609375 -7.359375 L 6.609375 -2.484375 C 6.609375 -1.929688 6.476562 -1.457031 6.21875 -1.0625 C 5.957031 -0.675781 5.609375 -0.378906 5.171875 -0.171875 C 4.734375 0.0234375 4.257812 0.125 3.75 0.125 C 3.226562 0.125 2.75 0.0234375 2.3125 -0.171875 C 1.882812 -0.378906 1.539062 -0.675781 1.28125 -1.0625 C 1.019531 -1.457031 0.890625 -1.929688 0.890625 -2.484375 L 0.890625 -7.359375 L 1.78125 -7.359375 L 1.78125 -2.484375 C 1.78125 -2.097656 1.867188 -1.769531 2.046875 -1.5 C 2.234375 -1.238281 2.472656 -1.039062 2.765625 -0.90625 C 3.066406 -0.769531 3.394531 -0.703125 3.75 -0.703125 C 4.09375 -0.703125 4.414062 -0.769531 4.71875 -0.90625 C 5.019531 -1.039062 5.257812 -1.238281 5.4375 -1.5 C 5.625 -1.769531 5.71875 -2.097656 5.71875 -2.484375 Z M 5.71875 -7.359375 "
  }))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.865829, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 3.375 -7.359375 C 3.945312 -7.359375 4.414062 -7.253906 4.78125 -7.046875 C 5.15625 -6.835938 5.429688 -6.554688 5.609375 -6.203125 C 5.785156 -5.847656 5.875 -5.457031 5.875 -5.03125 C 5.875 -4.59375 5.785156 -4.195312 5.609375 -3.84375 C 5.429688 -3.488281 5.160156 -3.207031 4.796875 -3 C 4.429688 -2.789062 3.960938 -2.6875 3.390625 -2.6875 L 1.78125 -2.6875 L 1.78125 0 Z M 1.78125 -3.46875 L 3.359375 -3.46875 C 3.953125 -3.46875 4.375 -3.613281 4.625 -3.90625 C 4.875 -4.207031 5 -4.582031 5 -5.03125 C 5 -5.46875 4.875 -5.832031 4.625 -6.125 C 4.375 -6.414062 3.945312 -6.5625 3.34375 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -3.46875 "
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.118721, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 3.375 -7.359375 C 3.945312 -7.359375 4.414062 -7.253906 4.78125 -7.046875 C 5.15625 -6.835938 5.429688 -6.554688 5.609375 -6.203125 C 5.785156 -5.847656 5.875 -5.457031 5.875 -5.03125 C 5.875 -4.59375 5.785156 -4.195312 5.609375 -3.84375 C 5.429688 -3.488281 5.160156 -3.207031 4.796875 -3 C 4.429688 -2.789062 3.960938 -2.6875 3.390625 -2.6875 L 1.78125 -2.6875 L 1.78125 0 Z M 1.78125 -3.46875 L 3.359375 -3.46875 C 3.953125 -3.46875 4.375 -3.613281 4.625 -3.90625 C 4.875 -4.207031 5 -4.582031 5 -5.03125 C 5 -5.46875 4.875 -5.832031 4.625 -6.125 C 4.375 -6.414062 3.945312 -6.5625 3.34375 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -3.46875 "
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(254.371613, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.09375 -3.671875 C 7.09375 -2.898438 6.953125 -2.226562 6.671875 -1.65625 C 6.390625 -1.09375 6.003906 -0.660156 5.515625 -0.359375 C 5.023438 -0.0546875 4.46875 0.09375 3.84375 0.09375 C 3.21875 0.09375 2.660156 -0.0546875 2.171875 -0.359375 C 1.679688 -0.660156 1.296875 -1.09375 1.015625 -1.65625 C 0.742188 -2.226562 0.609375 -2.898438 0.609375 -3.671875 C 0.609375 -4.453125 0.742188 -5.125 1.015625 -5.6875 C 1.296875 -6.25 1.679688 -6.679688 2.171875 -6.984375 C 2.660156 -7.296875 3.21875 -7.453125 3.84375 -7.453125 C 4.46875 -7.453125 5.023438 -7.296875 5.515625 -6.984375 C 6.003906 -6.679688 6.390625 -6.25 6.671875 -5.6875 C 6.953125 -5.125 7.09375 -4.453125 7.09375 -3.671875 Z M 6.234375 -3.671875 C 6.234375 -4.304688 6.125 -4.84375 5.90625 -5.28125 C 5.695312 -5.71875 5.410156 -6.050781 5.046875 -6.28125 C 4.691406 -6.507812 4.289062 -6.625 3.84375 -6.625 C 3.40625 -6.625 3.003906 -6.507812 2.640625 -6.28125 C 2.273438 -6.050781 1.988281 -5.71875 1.78125 -5.28125 C 1.570312 -4.84375 1.46875 -4.304688 1.46875 -3.671875 C 1.46875 -3.035156 1.570312 -2.5 1.78125 -2.0625 C 1.988281 -1.625 2.273438 -1.289062 2.640625 -1.0625 C 3.003906 -0.84375 3.40625 -0.734375 3.84375 -0.734375 C 4.289062 -0.734375 4.691406 -0.84375 5.046875 -1.0625 C 5.410156 -1.289062 5.695312 -1.625 5.90625 -2.0625 C 6.125 -2.5 6.234375 -3.035156 6.234375 -3.671875 Z M 6.234375 -3.671875 "
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(264.901336, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 3.375 -7.359375 C 3.945312 -7.359375 4.414062 -7.257812 4.78125 -7.0625 C 5.15625 -6.863281 5.429688 -6.59375 5.609375 -6.25 C 5.785156 -5.914062 5.875 -5.53125 5.875 -5.09375 C 5.875 -4.601562 5.757812 -4.175781 5.53125 -3.8125 C 5.3125 -3.457031 4.96875 -3.195312 4.5 -3.03125 L 6.15625 0 L 5.125 0 L 3.578125 -2.875 C 3.515625 -2.875 3.453125 -2.875 3.390625 -2.875 L 1.78125 -2.875 L 1.78125 0 Z M 1.78125 -3.671875 L 3.359375 -3.671875 C 3.953125 -3.671875 4.375 -3.796875 4.625 -4.046875 C 4.875 -4.304688 5 -4.65625 5 -5.09375 C 5 -5.539062 4.867188 -5.894531 4.609375 -6.15625 C 4.359375 -6.425781 3.9375 -6.5625 3.34375 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -3.671875 "
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.197264, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 -6.5625 L 0.484375 -7.359375 L 6 -7.359375 L 6 -6.5625 L 3.6875 -6.5625 L 3.6875 0 L 2.796875 0 L 2.796875 -6.5625 Z M 0.484375 -6.5625 "
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.521887, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(289.20254, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.90625 -5.515625 C 4.863281 -5.878906 4.6875 -6.160156 4.375 -6.359375 C 4.070312 -6.554688 3.703125 -6.65625 3.265625 -6.65625 C 2.773438 -6.65625 2.378906 -6.539062 2.078125 -6.3125 C 1.785156 -6.082031 1.640625 -5.789062 1.640625 -5.4375 C 1.640625 -5.175781 1.71875 -4.960938 1.875 -4.796875 C 2.039062 -4.640625 2.234375 -4.515625 2.453125 -4.421875 C 2.671875 -4.335938 2.875 -4.269531 3.0625 -4.21875 L 3.8125 -4.015625 C 4 -3.960938 4.207031 -3.890625 4.4375 -3.796875 C 4.675781 -3.710938 4.90625 -3.59375 5.125 -3.4375 C 5.34375 -3.289062 5.519531 -3.097656 5.65625 -2.859375 C 5.800781 -2.628906 5.875 -2.34375 5.875 -2 C 5.875 -1.601562 5.769531 -1.242188 5.5625 -0.921875 C 5.351562 -0.597656 5.050781 -0.34375 4.65625 -0.15625 C 4.257812 0.03125 3.78125 0.125 3.21875 0.125 C 2.425781 0.125 1.796875 -0.0546875 1.328125 -0.421875 C 0.867188 -0.796875 0.617188 -1.285156 0.578125 -1.890625 L 1.5 -1.890625 C 1.519531 -1.617188 1.609375 -1.390625 1.765625 -1.203125 C 1.929688 -1.023438 2.140625 -0.890625 2.390625 -0.796875 C 2.648438 -0.710938 2.925781 -0.671875 3.21875 -0.671875 C 3.550781 -0.671875 3.851562 -0.726562 4.125 -0.84375 C 4.394531 -0.957031 4.609375 -1.113281 4.765625 -1.3125 C 4.929688 -1.507812 5.015625 -1.742188 5.015625 -2.015625 C 5.015625 -2.253906 4.945312 -2.453125 4.8125 -2.609375 C 4.675781 -2.765625 4.492188 -2.890625 4.265625 -2.984375 C 4.046875 -3.078125 3.804688 -3.160156 3.546875 -3.234375 L 2.640625 -3.484375 C 2.066406 -3.648438 1.613281 -3.882812 1.28125 -4.1875 C 0.945312 -4.5 0.78125 -4.90625 0.78125 -5.40625 C 0.78125 -5.8125 0.890625 -6.164062 1.109375 -6.46875 C 1.335938 -6.78125 1.640625 -7.019531 2.015625 -7.1875 C 2.390625 -7.363281 2.8125 -7.453125 3.28125 -7.453125 C 3.757812 -7.453125 4.179688 -7.367188 4.546875 -7.203125 C 4.921875 -7.035156 5.210938 -6.804688 5.421875 -6.515625 C 5.640625 -6.222656 5.753906 -5.890625 5.765625 -5.515625 Z M 4.90625 -5.515625 "
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.48412, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 5.328125 -7.359375 L 5.328125 -6.5625 L 1.78125 -6.5625 L 1.78125 -4.078125 L 5.09375 -4.078125 L 5.09375 -3.28125 L 1.78125 -3.28125 L 1.78125 -0.796875 L 5.390625 -0.796875 L 5.390625 0 Z M 0.890625 0 "
  }))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.364008, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 3.375 -7.359375 C 3.945312 -7.359375 4.414062 -7.257812 4.78125 -7.0625 C 5.15625 -6.863281 5.429688 -6.59375 5.609375 -6.25 C 5.785156 -5.914062 5.875 -5.53125 5.875 -5.09375 C 5.875 -4.601562 5.757812 -4.175781 5.53125 -3.8125 C 5.3125 -3.457031 4.96875 -3.195312 4.5 -3.03125 L 6.15625 0 L 5.125 0 L 3.578125 -2.875 C 3.515625 -2.875 3.453125 -2.875 3.390625 -2.875 L 1.78125 -2.875 L 1.78125 0 Z M 1.78125 -3.671875 L 3.359375 -3.671875 C 3.953125 -3.671875 4.375 -3.796875 4.625 -4.046875 C 4.875 -4.304688 5 -4.65625 5 -5.09375 C 5 -5.539062 4.867188 -5.894531 4.609375 -6.15625 C 4.359375 -6.425781 3.9375 -6.5625 3.34375 -6.5625 L 1.78125 -6.5625 Z M 1.78125 -3.671875 "
  }))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.659935, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.1875 -7.359375 L 3.375 -1.15625 L 3.453125 -1.15625 L 5.640625 -7.359375 L 6.578125 -7.359375 L 3.875 0 L 2.953125 0 L 0.265625 -7.359375 Z M 1.1875 -7.359375 "
  }))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.328875, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.78125 -7.359375 L 1.78125 0 L 0.890625 0 L 0.890625 -7.359375 Z M 1.78125 -7.359375 "
  }))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(331.83737, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.8125 -5.046875 L 5.921875 -5.046875 C 5.847656 -5.390625 5.707031 -5.675781 5.5 -5.90625 C 5.300781 -6.144531 5.054688 -6.320312 4.765625 -6.4375 C 4.484375 -6.5625 4.175781 -6.625 3.84375 -6.625 C 3.40625 -6.625 3.003906 -6.507812 2.640625 -6.28125 C 2.273438 -6.050781 1.988281 -5.71875 1.78125 -5.28125 C 1.570312 -4.84375 1.46875 -4.304688 1.46875 -3.671875 C 1.46875 -3.035156 1.570312 -2.5 1.78125 -2.0625 C 1.988281 -1.625 2.273438 -1.289062 2.640625 -1.0625 C 3.003906 -0.84375 3.40625 -0.734375 3.84375 -0.734375 C 4.175781 -0.734375 4.484375 -0.789062 4.765625 -0.90625 C 5.054688 -1.03125 5.300781 -1.207031 5.5 -1.4375 C 5.707031 -1.664062 5.847656 -1.953125 5.921875 -2.296875 L 6.8125 -2.296875 C 6.71875 -1.796875 6.53125 -1.363281 6.25 -1 C 5.96875 -0.644531 5.617188 -0.375 5.203125 -0.1875 C 4.796875 0 4.34375 0.09375 3.84375 0.09375 C 3.21875 0.09375 2.660156 -0.0546875 2.171875 -0.359375 C 1.679688 -0.660156 1.296875 -1.09375 1.015625 -1.65625 C 0.742188 -2.226562 0.609375 -2.898438 0.609375 -3.671875 C 0.609375 -4.453125 0.742188 -5.125 1.015625 -5.6875 C 1.296875 -6.25 1.679688 -6.679688 2.171875 -6.984375 C 2.660156 -7.296875 3.21875 -7.453125 3.84375 -7.453125 C 4.34375 -7.453125 4.796875 -7.351562 5.203125 -7.15625 C 5.617188 -6.96875 5.96875 -6.695312 6.25 -6.34375 C 6.53125 -5.988281 6.71875 -5.554688 6.8125 -5.046875 Z M 6.8125 -5.046875 "
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.022769, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.890625 0 L 0.890625 -7.359375 L 5.328125 -7.359375 L 5.328125 -6.5625 L 1.78125 -6.5625 L 1.78125 -4.078125 L 5.09375 -4.078125 L 5.09375 -3.28125 L 1.78125 -3.28125 L 1.78125 -0.796875 L 5.390625 -0.796875 L 5.390625 0 Z M 0.890625 0 "
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "#002b4b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.902657, 105.871855)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.90625 -5.515625 C 4.863281 -5.878906 4.6875 -6.160156 4.375 -6.359375 C 4.070312 -6.554688 3.703125 -6.65625 3.265625 -6.65625 C 2.773438 -6.65625 2.378906 -6.539062 2.078125 -6.3125 C 1.785156 -6.082031 1.640625 -5.789062 1.640625 -5.4375 C 1.640625 -5.175781 1.71875 -4.960938 1.875 -4.796875 C 2.039062 -4.640625 2.234375 -4.515625 2.453125 -4.421875 C 2.671875 -4.335938 2.875 -4.269531 3.0625 -4.21875 L 3.8125 -4.015625 C 4 -3.960938 4.207031 -3.890625 4.4375 -3.796875 C 4.675781 -3.710938 4.90625 -3.59375 5.125 -3.4375 C 5.34375 -3.289062 5.519531 -3.097656 5.65625 -2.859375 C 5.800781 -2.628906 5.875 -2.34375 5.875 -2 C 5.875 -1.601562 5.769531 -1.242188 5.5625 -0.921875 C 5.351562 -0.597656 5.050781 -0.34375 4.65625 -0.15625 C 4.257812 0.03125 3.78125 0.125 3.21875 0.125 C 2.425781 0.125 1.796875 -0.0546875 1.328125 -0.421875 C 0.867188 -0.796875 0.617188 -1.285156 0.578125 -1.890625 L 1.5 -1.890625 C 1.519531 -1.617188 1.609375 -1.390625 1.765625 -1.203125 C 1.929688 -1.023438 2.140625 -0.890625 2.390625 -0.796875 C 2.648438 -0.710938 2.925781 -0.671875 3.21875 -0.671875 C 3.550781 -0.671875 3.851562 -0.726562 4.125 -0.84375 C 4.394531 -0.957031 4.609375 -1.113281 4.765625 -1.3125 C 4.929688 -1.507812 5.015625 -1.742188 5.015625 -2.015625 C 5.015625 -2.253906 4.945312 -2.453125 4.8125 -2.609375 C 4.675781 -2.765625 4.492188 -2.890625 4.265625 -2.984375 C 4.046875 -3.078125 3.804688 -3.160156 3.546875 -3.234375 L 2.640625 -3.484375 C 2.066406 -3.648438 1.613281 -3.882812 1.28125 -4.1875 C 0.945312 -4.5 0.78125 -4.90625 0.78125 -5.40625 C 0.78125 -5.8125 0.890625 -6.164062 1.109375 -6.46875 C 1.335938 -6.78125 1.640625 -7.019531 2.015625 -7.1875 C 2.390625 -7.363281 2.8125 -7.453125 3.28125 -7.453125 C 3.757812 -7.453125 4.179688 -7.367188 4.546875 -7.203125 C 4.921875 -7.035156 5.210938 -6.804688 5.421875 -6.515625 C 5.640625 -6.222656 5.753906 -5.890625 5.765625 -5.515625 Z M 4.90625 -5.515625 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.6e66bd97587c99627f4bd4d3981b5fab.svg";
export { ForwardRef as ReactComponent };